import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { Button, type ButtonProps } from "@mui/material";

const archiveIconSx = { color: "#F59E0B" };
const unarchiveIconSx = { color: "#10B981" };

const actionButtonSx = {
  fontSize: "12px",
  textTransform: "none" as const,
  padding: "4px 12px",
  "&:hover": {
    backgroundColor: "rgba(108, 114, 147, 0.04)",
  },
};

const archiveButtonSx = {
  color: "#F59E0B",
  borderColor: "#F59E0B",
  "&:hover": {
    borderColor: "#D97706",
    backgroundColor: "rgba(245, 158, 11, 0.10)",
  },
};

const unarchiveButtonSx = {
  color: "#047857",
  borderColor: "#10B981",
  "&:hover": {
    borderColor: "#059669",
    backgroundColor: "rgba(16, 185, 129, 0.10)",
  },
};

type ActionButtonProps = Omit<ButtonProps, "variant" | "size" | "children" | "startIcon">;

export function ArchiveActionButton({ sx, ...rest }: ActionButtonProps) {
  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<ArchiveIcon fontSize="small" sx={archiveIconSx} />}
      sx={{ ...actionButtonSx, ...archiveButtonSx, ...sx }}
      {...rest}
    >
      Archive
    </Button>
  );
}

export function UnarchiveActionButton({ sx, ...rest }: ActionButtonProps) {
  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<UnarchiveIcon fontSize="small" sx={unarchiveIconSx} />}
      sx={{ ...actionButtonSx, ...unarchiveButtonSx, ...sx }}
      {...rest}
    >
      Unarchive
    </Button>
  );
}
